export const housekeepingDrawer = {
  close: "Close",
  guest: "Guest",

  cleaning: {
    title: "Cleaning status",
    lastCleaned: "Cleaned {date}",
    evidenceAlt: "evidence",
  },

  status: {
    dirty: "To clean",
    in_progress: "In progress",
    clean: "Clean",
    inspected: "Inspected",
    out_of_service: "Out of service",
  },

  occupancy: {
    title: "Occupancy",
    aboutToLeave: "About to leave",
    checkIn: "Check-in {date}",
    checkOut: "Check-out {date}",
    checkoutTime: "Checkout {time}",
    booking: "Booking {code}",
    nextArrivalToday: "Next arrival today",
    fromTime: "from {time}",
    labels: {
      vacant: "Vacant",
      occupied: "Occupied",
      departure_today: "Departs today",
      arrival_today: "Arrives today",
      turnover: "Departure and arrival today",
    },
  },

  window: {
    windowLabel: "Window",
    standardSchedule: "Standard schedule",
    sub: "{label}: checkout {checkout} → check-in {checkin}",
    overdue: "Arrival overdue · prioritize this cleaning",
    untilArrival: "{dur} until arrival",
  },

  tasks: {
    title: "Cleaning tasks",
    // Pluralization (vue-i18n v8 pipes) — choiceIndex = number of open tasks
    pendingCount: "{count} pending | {count} pending",
    newPlaceholder: "Add a task (e.g. Change towels)",
    priorityTitle: "Priority",
    dateTitle: "Date",
    timeTitle: "Time (optional)",
    assignTitle: "Assign to",
    assignAllOption: "Everyone (cleaning and maintenance)",
    byRole: "By role",
    wholeRoleSuffix: "(entire role)",
    people: "People",
    add: "Add",
    adding: "Adding…",
    loading: "Loading tasks…",
    empty: "No tasks. Add the first one above.",
    markPending: "Mark as pending",
    markDone: "Mark as done",
    priorityDotTitle: "Priority {priority}",
    delete: "Delete",
  },

  enc: {
    late: "Overdue",
    title: "Requests for this room",
    what: "One-off things besides the cleaning: restock something, check a fault, a treat for the guest. Whoever goes to the room will see it and tick it off.",
    protocolNote: "The cleaning steps are in the protocol above. This is only for extras.",
    emptyTitle: "No pending requests",
    emptyExamples: "For example: “Replace the bathroom light bulb” or “Leave a welcome bottle of wine”.",
    newBtn: "New request",
    qWhat: "What needs doing?",
    whatPlaceholder: "Write it in your own words…",
    suggestions: "Restock coffee and sugar | Replace a light bulb | Check the air conditioning | Leave extra towels | Check the wifi | Welcome treat",
    qWhen: "When?",
    today: "Today",
    tomorrow: "Tomorrow",
    otherDay: "Another day",
    anyDay: "No date",
    atTime: "At a specific time",
    qWho: "Who does it?",
    whoever: "Whoever cleans",
    isUrgent: "It's urgent",
    urgentHint: "It will stand out and be flagged first.",
    urgent: "Urgent",
    preview: "“{what}” · {when} · {who}",
    cancel: "Cancel",
    save: "Save request",
    showDone: "Show {count} done | Show {count} done",
    hideDone: "Hide done",
    confirmDelete: "Delete the request “{what}”?",
  },

  priority: {
    low: "Low",
    normal: "Normal",
    high: "High",
    urgent: "Urgent",
  },

  roles: {
    limpieza: "Cleaning",
    mantenimiento: "Maintenance",
    propietario: "Owner",
  },

  assignee: {
    assigned: "Assigned",
    all: "Everyone",
  },
};
